
import { Component, Vue, Watch } from "vue-property-decorator";
import { IDefaultShippingOrderModel, ITypeModel } from "@/api/types";

import Pagination from "@/components/Pagination/index.vue";
import { TagsViewModule } from '@/store/modules/tags-view'

import {
  auditHold,
  auditCancelHold,
  generatePI,
  auditPass,
  getDraftPriceType,
  getRecordsStatus,
  getDistributeDeposit,
  getRemainingDeposit,
} from "@/api/inquiry";
import {
  invalidPurchaseOrder,
  deleteShippingMarks,
  putRemark,
  uploadInfoFile,
} from "@/api/proforma";
import {
  getHeaderInfo,
  getDeliveryVerificationList,
  resetAmount,
  updateAmount,
  getModelType,
  updateModel,
  getReMatchPackingList,
  getSuppliers,
  cloneOrderMoney,
  updateToPoModel,
  getCanSave, queryMarkLetter, deleteByReUpload,
} from "@/api/purchase-order";
import { issuance, saveToPackingList } from "@/api/factory-packing-list";

import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { cal } from "@/utils/cal";
import {downloadHqPackingList, getMark, updateHqPackingListFile, updateMark} from "@/api/hq-packing-list";
import { downloadFiles } from "@/utils/oss-download";

@Component({
  name: "deliveryVerification",
  components: {
    Pagination,
    ModifyNumber: () => import("./components/ModifyNumber.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private isShowMore = false;
  private isShowMore2 = false;
  private isShowMore3 = false;
  private showMatching = false;
  private showModify = false;
  private showList = false;
  private showMarks = false;
  private showRemarks = false;
  private markInput = [];
  private updateMarkVisible = false;
  private saveSubmitLoading = false; // 确认创建
  private saveRematchLoading = false; // 重新匹配
  private saveToZXDLoading = false; // 保存到装箱单

  private type = "";
  private remark = "";
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();
  private conversionExchangeRate = 0;
  private id = "";

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  private headForm = {
    supplierId: "",
    packingListRemark: "",
    subWarehouseReceiptRemark: "",
    code: "",
  };
  private listParam = {
    result: null,
  };
  public loading: Boolean = false;
  public searchForm = [
    {
      label: "校验结果",
      prop: "result",
      key: "result",
      type: "select",
      value: "",
      placeholder: "",
      clearable: true,
      options: [
        {
          name: "订单未完成",
          id: "订单未完成",
        },
        {
          name: "交货完成（超发/欠发）",
          id: "交货完成（超发/欠发）",
        },
        {
          name: "交货完成",
          id: "交货完成",
        },
        {
          name: "金额不符",
          id: "金额不符",
        },
        {
          name: "未找到数据",
          id: "未找到数据",
        },
        {
          name: "超发",
          id: "超发",
        },
      ],
    },
  ];
  private selectedHqNumber = false;
  private selectedJrNumber = false;
  public tableCol = [
    {
      label: "采购订单号",
      prop: "purchaseOrderNumber",
      key: "purchaseOrderNumber",
      show: true,
      disabled: false,
      fixed: true,
      // type: "link",
      width: 130,
    },
    {
      label: "华强交易号码（采购订单）",
      prop: "hqTransactionNumber",
      key: "hqTransactionNumber",
      show: true,
    },
    {
      label: "客人号码1",
      prop: "customerNumber",
      key: "customerNumber",
      show: true,
    },
    {
      label: "华强号码",
      prop: "hqOrJrNumber",
      key: "hqOrJrNumber",
      show_key:"show1"
    },
    {
      label: "嘉锐号码",
      prop: "hqOrJrNumber",
      key: "hqOrJrNumber",
      show_key:"show2"
    },
    {
      label: "OE号码",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
    },
    {
      label: "REF",
      prop: "refNumber",
      key: "refNumber",
      show: true,
    },
    {
      label: "未上传数量",
      prop: "noUploadedQuantity",
      key: "noUploadedQuantity",
      show: true,
    },
    {
      label: "装箱单数量",
      prop: "quantity",
      key: "quantity",
      show: true,
      type: "step_warn",
      multipleOfProp: "purchaseQuantityStep",
      tooltipContent: (row) =>
          `【装箱单数量】(${row.quantity})不是【采购计价单位】(${row.purchaseQuantityStep})的倍数，将不能生成装箱单。`,
    },
    {
      label: "剩余未交货",
      prop: "noDeliveryQuantity",
      key: "noDeliveryQuantity",
      show: true,
      type: "actions",
      options: [
        {
          prop: "noDeliveryQuantity",
          type: "text",
        },
        {
          name: "超发",
          code: "",
          click: "handleOver",
          key: "showMore",
          value: true,
        },
        {
          name: "欠发",
          code: "",
          click: "handleUnder",
          key: "showLess",
          value: true,
        },
      ],
      width: 120,
    },
    {
      label: "下单金额",
      prop: "poUnitPrice",
      key: "poUnitPrice",
      show: true,
      disabled: false,
      type: "price_hint",
      tooltipContent: (row) =>
          `采购计价单位:${row.purchaseQuantityStep}\n\n注意：【装箱单数量】必须是【采购计价单位】的倍数。\n\n因要满足产品的采购总价必须要两位小数以内。`,
    },
    {
      label: "装箱单金额",
      prop: "productUnitPrice",
      key: "productUnitPrice",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 4,
    },
    {
      label: "校验结果",
      prop: "result",
      key: "result",
      show: true,
      disabled: false,
    },
    {
      label: "库存交货",
      prop: "inventoryProgress",
      key: "inventoryProgress",
      show: true,
      disabled: false,
    },
    {
      label: "库存校验",
      prop: "inventoryResult",
      key: "inventoryResult",
      show: true,
      disabled: false,
    },
  ] as any;
  private list = [
    {
      label: "供应商简称",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote: false,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
      rules: [{ required: true, message: "请选择供应商", trigger: "blur" }],
    },
    {
      label: "校验货款",
      prop: "poAmount",
      key: "poAmount",
      type: "input",
      placeholder: "校验货款",
      clearable: true,
      maxlength: 10,
    },
    {
      label: "货款总金额",
      prop: "packingListAmount",
      key: "packingListAmount",
      type: "input",
      placeholder: "货款总金额",
      clearable: true,
      readonly: true,
      maxlength: 50,
    },
    {
      label: "发货总金额",
      prop: "totalAmount",
      key: "totalAmount",
      type: "input",
      placeholder: "发货总金额",
      clearable: true,
      readonly: true,
      maxlength: 50,
    },
    {
      label: "交货日期",
      prop: "paymentTime",
      key: "paymentTime",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "装箱单号",
      prop: "code",
      key: "code",
      type: "input",
      placeholder: "装箱单号",
      clearable: true,
      readonly: true,
      maxlength: 50,
    },
    {
      label: "子进仓单备注",
      prop: "subWarehouseReceiptRemark",
      key: "subWarehouseReceiptRemark",
      type: "textarea",
      placeholder: "子进仓单备注",
      clearable: true,
      readonly: true,
      maxlength: 50,
    },
    {
      label: "装箱单备注",
      prop: "packingListRemark",
      key: "packingListRemark",
      type: "textarea",
      placeholder: "",
      clearable: true,
      maxlength: 50,
    },

    {
      label: "剩余定金",
      prop: "remainingDeposit",
      key: "remainingDeposit",
      type: "input",
      value: 0,
      placeholder: "剩余定金",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "本次分配定金",
      prop: "thisDistributionDeposit",
      key: "thisDistributionDeposit",
      type: "input",
      value: 0,
      placeholder: "本次分配定金",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "扣款总额",
      prop: "deductAmount",
      key: "deductAmount",
      type: "input",
      placeholder: "扣款总额",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "补款总额",
      prop: "supplementAmount",
      key: "supplementAmount",
      type: "input",
      placeholder: "补款总额",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "索赔抵扣",
      prop: "deductionAmount",
      key: "deductionAmount",
      type: "input",
      placeholder: "索赔抵扣",
      clearable: true,
      maxlength: 50,
    },
  ];
  public customerInfo = {} as any;
  public selectedItem = {} as any;
  public customerStatus = "";
  public customerInfoFields = [
    {
      label: "PI NO.",
      key: "piNumber",
    },
    {
      label: "交易公司",
      key: "company",
    },
    {
      label: "当前状态",
      key: "status",
    },
    {
      label: "客人信息",
      key: "customerAbbr",
    },
    {
      label: "客人国家",
      key: "customerNation",
    },
    {
      label: "长期定金",
      key: "longTermDeposit",
    },
    {
      label: "产品接单数量",
      key: "shipmentQuantity",
    },
    {
      label: "PI金额",
      key: "proformaInvoiceAmount",
    },
    {
      label: "PI生成时间",
      key: "createdTime",
    },
    {
      label: "产品下单数量",
      key: "deliveryQuantity",
    },
    {
      label: "下单金额",
      key: "deliveryAmount",
    },
    {
      label: "下单时间",
      key: "orderPlacementTime",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  private markLetters = [];

  private isReUpload = false;

  get showPI() {
    return this.customerStatus === "审批通过";
  }

  get showHold() {
    return this.customerStatus === "待审核";
  }

  get showCancelHold() {
    return this.customerStatus === "已挂起";
  }

  get showPass() {
    return "待审核,已挂起".indexOf(this.customerStatus) > -1 ? true : false;
  }

  created() {
    this.id = (this.$route.query.hqPackingListId as string) || "";
    if (!this.id) {
      console.log("没有id");
      return;
    }
    if (this.$route.query.hqPackingListCode) {
      this.headForm.code = this.$route.query.hqPackingListCode as any;
    }
    if(this.$route.query.isReUpload) {
      this.isReUpload = JSON.parse(this.$route.query.isReUpload as any);
    }
    this.init();
    this.getModelType();
  }

  // activated() {
  //   this.id = (this.$route.query.hqPackingListId as string) || "";
  //   if (!this.id) {
  //     console.log("没有id");
  //     return;
  //   }
  //   this.init();
  // }

  private init() {
    this.getHeaderInfo();
    this.getSuppliersList();
    // this.defNumber();
    // this.getConversionExchangeRate();
    this.getList();
  }

  private async defNumber() {
    let params = {
      hqPackingListId: this.$route.query.hqPackingListId,
    };
    if (!this.headForm.supplierId) {
      this.$notify.error("当前装箱单中所有采购订单号均找不到供应商");
      return;
    }
    let params1 = {
      supplierId: this.headForm.supplierId,
    };
    let obj = {
      remainingDeposit: 0,
      allocatedDepositOfThisTime: 0,
    };
    const res1 = await getDistributeDeposit(params);
    // this.list[this.list.findIndex(item => item.label === "本次分配定金")].value = res1 as any
    if (res1.data) {
      obj.allocatedDepositOfThisTime = res1.data as any;
    }
    const res2 = await getRemainingDeposit(params1);
    // this.list[this.list.findIndex(item => item.label === "剩余定金")].value = res2 as any
    if (res2.data) {
      obj.remainingDeposit = res2.data as any;
    }
    this.headForm = Object.assign({}, this.headForm, obj);
  }

  // 更新型号为PO中的号码
  private async updateToPoModelIDS() {
    if (this.selectedRows.length == 0) {
      this.$notify.error("请选择需要更新的数据");
      return;
    } else {
      let params = {
        groupInfoIds: [],
      };
      this.selectedRows.forEach((item) => {
        params.groupInfoIds.push(item.groupInfoId);
      });
      await updateToPoModel(params);
      this.$notify({
        title: "成功",
        message: "更新成功",
        type: "success",
        duration: 2000,
      });
      // this.getList();
      // this.selectedRows = [];
    }
  }

  /**
   * 清除当前的交货校验信息，并关闭当前标签页。如果存在其他非固定的相邻标签页，则跳转到该标签页；若无，则跳转至首页。
   * @return {void}
   */
  private  async clearPackingGroupAndCloseThisTag() {
    await deleteByReUpload(this.id).then(() =>
      this.closeTabAndFindNextRoute()).catch((err) => console.error(err));
  }

  /**
   * 关闭当前标签页，并查找并跳转到下一个相邻的非固定标签页。如果不存在这样的标签页，则跳转到首页。
   * @return {void}
   */
  private closeTabAndFindNextRoute() {
    // 获取当前路由和标签页列表
    const currentRoute = this.$route;
    const visitedViews = TagsViewModule.visitedViews;

    // 查找当前路由在标签页列表中的索引
    const currentIndex = visitedViews.findIndex(v => v.path === currentRoute.path);

    // 关闭当前标签页
    TagsViewModule.delView(currentRoute);

    if (currentIndex > -1) {
      let targetRoute = null;

      // 首先查找右侧相邻标签页
      for (let i = currentIndex; i < visitedViews.length; i++) {
        const view = visitedViews[i];
        // 跳过固定标签页（affix）和刚删除的标签页
        if (!(view.meta && view.meta.affix) && view.path !== currentRoute.path) {
          targetRoute = view;
          break;
        }
      }

      // 如果右侧没有非固定标签页，查找左侧
      if (!targetRoute) {
        for (let i = currentIndex - 1; i >= 0; i--) {
          const view = visitedViews[i];
          // 跳过固定标签页（affix）
          if (!(view.meta && view.meta.affix)) {
            targetRoute = view;
            break;
          }
        }
      }

      // 如果找到了目标路由，跳转到该路由
      if (targetRoute) {
        this.$router.push({
          path: targetRoute.path,
          query: targetRoute.query,
          params: targetRoute.params
        });
      } else {
        // 如果没有其他标签页，跳转到首页
        this.$router.push('/');
      }
    } else {
      // 如果当前路由不在标签页列表中，跳转到首页
      this.$router.push('/');
    }
  }

  private handleSuccess() {
    this.showMatching = false;
    this.getList();
  }

  private async getSuppliersList() {
    const res: any = await this.getSuppliers();
    if (res.length && res.length === 0) {
      this.$notify.error("暂无供应商");
    }
    this.list[0].options = res;
  }

  private async getSuppliers() {
    const res: any = await getSuppliers({ hqPackingListId: this.id });
    return res;
  }

  private async getRecordsStatus() {
    const res: any = await getRecordsStatus(this.customerInfo.approvalRecordId);
    this.customerStatus = res.data;
  }

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    let index = this.tableCol.findIndex((item) => {
      return item.key === "unitPriceType";
    });
    this.tableCol[index].typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { ...rest } = params;
    this.listParam = rest;
    this.getList();
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  public handleCommand(command) {
    this[command]();
  }

  private handleMarks() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择");
      return;
    }
    this.showMarks = true;
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPurchaseOrder(scope.row.id);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private modelType = [] as any;

  private dioClose() {
    (this.$refs.table as any).$refs.table.clearSelection();
  }

  // getModelType
  private async getModelType() {
    const res: any = await getModelType();
    this.modelType = res;
  }

  public handleCommandEdit(command) {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择");
      return;
    }
    if (this.selectedRows.length !== 1) {
      this.$notify.error("只能选择一条数据");
      return;
    }
    this.type = command;
    // this.handleBatchModify(command);
    this.showModify = true;
    // this[command]();
  }

  // 修改号码
  private async handleBatchModify(type) {
    this.$confirm("选中的行将会替换为原型号，确定要修正吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let params = {
          type,
        };
        await updateModel(type, params);
        this.confirmSuccess();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 导出excel
  private isExporting = false;

  // 导出
  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `交货校验-${new Date()}`
    );
    this.isExporting = false;
  }

  private async getHeaderInfo() {
    const res: any = await getHeaderInfo(this.id);
    this.headForm = res;
    this.defNumber();
  }

  private handleRemarks() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择");
      return;
    }
    this.showRemarks = true;
  }

  private async changeRemark() {
    const ids = this.selectedRows.map((item) => {
      return item.id;
    });
    await putRemark({
      remark: this.remark,
      ids,
    });
    this.confirmSuccess();
    this.showRemarks = false;
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      await putRemark({
        remark: item.remark,
        ids: [item.id],
      });
      this.confirmSuccess();
    } catch (e) {
      await this.getList();
    }
  }

  // 上传
  private async handleUpload(val) {
    const { file, item } = val;
    let formData = new FormData();
    formData.append("poId", item.id);
    formData.append("receipt", "false");
    formData.append("files", file.file);
    await uploadInfoFile(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private linkClick(scope) {
    this.$router.push(`/orderDetails?id=${scope.row.id}`);
  }

  private handleOver(scope) {
    this.issuance("OVERDELIVERY", scope.row);
  }

  private handleUnder(scope) {
    this.issuance("UNDERDELIVERY", scope.row);
  }

  // issuance
  private async issuance(status, item) {
    this.$confirm("确定要执行此操作吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      await issuance({
        hqPackingListId: this.$route.query.hqPackingListId,
        poInfoId: item.poInfoId,
        quantity: item.noDeliveryQuantity,
        status,
        productGroupInfoId: item.groupInfoId,
      });
      this.confirmSuccess();
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.init();
    (this.$refs.table as any).$refs.table.clearSelection();
    console.log(11111111);
  }

  private cancelAuditHold() {
    this.$confirm("确定取消挂起吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditCancelHold({
          id: this.customerInfo.approvalRecordId,
        });
        this.$notify({
          title: "成功",
          message: "取消成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private editAuditHold() {
    this.$prompt("请输入挂起原因", "编辑挂起原因", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "编辑挂起原因成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  // 挂起
  private async handleAuditHold() {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "挂起成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  // 审核通过
  public async handleAuditPass() {
    this.$confirm("确定审核通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(this.customerInfo.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审核通过",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public async handleDelete(scope) {
    await deleteShippingMarks(scope.row.id);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 交货进度
  public async handleDelivery() {
    this.showList = true;
  }

  private async getList() {
    this.loading = true;
    const params = {
      packingListId: this.id,
    };
    const res: any = await getDeliveryVerificationList(params);
    res.forEach((item) => {
      this.getNoDeliveryQuantity(item);
    });
    if (this.listParam.result) {
      this.table.list = res.filter(
        (item) => item.result === this.listParam.result
      );
      this.table.total = this.table.list.length;
    } else {
      this.table.total = res.length;
      this.table.list = res;
    }
    if(this.table.list.length > 0) {
     this.selectedHqNumber =  this.table.list[0].selectedHqNumber;
     this.selectedJrNumber =  this.table.list[0].selectedJrNumber;
    }
    this.loading = false;
  }

  private getNoDeliveryQuantity(item) {
    if (!item.noUploadedQuantity || !item.quantity) {
      return;
    }
    // 未上传数量-装箱单数量
    const noDeliveryQuantity = +cal.jian(
      item.noUploadedQuantity,
      item.quantity
    );
    this.$set(item, "noDeliveryQuantity", noDeliveryQuantity);
    if (noDeliveryQuantity < 0 && item.result.indexOf("超发") > -1) {
      this.$set(item, "showMore", true);
    }
    if (noDeliveryQuantity > 0 && item.result.indexOf("订单未完成") > -1) {
      this.$set(item, "showLess", true);
    }
  }

  private async doDownload() {
    const response: any = await downloadHqPackingList({
      hqPackingListIds: [this.id],
    });
    const resultUrl: string[] = response;
    if (resultUrl.length > 0) {
      downloadFiles(resultUrl);
    }
  }

  // 重置金额
  private async handleResetAmount() {
    this.$confirm("确定重置金额吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await resetAmount(this.id);
        this.$notify({
          title: "成功",
          message: "重置金额成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 重新上传
  private handleReUpload() {
    this.$confirm(
      "重新上传工厂箱单，丢弃所有校验结果，需要重新进行格式校验",
      "重新上传",
      {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(() => {
        // this.$router.push(`/factory-packing-list?id=${this.id}`);
        this.$router.push(`/factory-packing-list`);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 重新匹配
  private handleReMatch() {
    this.saveRematchLoading = true;
    if (!this.selectedRows.length) {
      this.$notify.error("请选择");
      this.saveRematchLoading = false;
      return;
    }
    this.$confirm("确定重新匹配？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let groupInfoIds = this.selectedRows.map((item) => item.groupInfoId);
        await getReMatchPackingList({
          groupInfoIds,
          packingListId: this.id,
        });
        await this.getList();
        this.saveRematchLoading = false;
        this.confirmSuccess();
      })
      .catch((err) => {
        this.saveRematchLoading = false;
        console.error(err);
      });
  }

  // 复制下单金额
  private async handleCopyAmount() {
    // if (!this.selectedRows.length) {
    //   this.$notify.error("请选择");
    //   return;
    // }
    // this.table.list.forEach(item => {
    //   item.productUnitPrice = item?.poUnitPrice || item.productUnitPrice;
    // });
    await cloneOrderMoney(this.id);
    this.getList();
    this.confirmSuccess();
    // let list = deepClone(this.selectedRows);
    // list.forEach(item => {
    //   item.productUnitPrice = item?.poUnitPrice;
    // });
  }

  public async inputChange({ val, row, column }) {
    // console.log(val, row, column);
    console.log("row", row.row);
    if (
      row.row.result == "超发" ||
      row.row.result == "欠发" ||
      row.row.result == "交货完成" ||
      row.row.result === "订单异常"
    ) {
      this.$notify({
        title: "修改失败",
        message: `状态为${row.row.result},不可更改装箱单金额`,
        type: "error",
        duration: 2000,
      });
    } else {
      await this.handleEditAmount(row.row);
    }
  }

  // 修改金额
  private async handleEditAmount(row) {
    await updateAmount(row.groupInfoId, {
      amount: row.productUnitPrice.toFixed(2),
    });
    this.$notify({
      title: "成功",
      message: "修改金额成功",
      type: "success",
      duration: 2000,
    });
    await this.getList();
  }

  private async submitForm(created): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            // 检验是否可以创建/保存
            let params = {
              packingListId: this.id,
            };
            await getCanSave(params)
              .then(async (res) => {
                this.$confirm(`确定${created?'保存':'创建'}吗？`, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(async () => {
                  await this.saveToPackingList(created);
                })
                .catch((err) => {
                  console.error(err);
                  this.saveSubmitLoading = false;
                  (this.$refs.table as any).$refs.table.clearSelection();
                });
              })
              .catch((err) => {
                console.log(err);
                this.saveSubmitLoading = false;
                (this.$refs.table as any).$refs.table.clearSelection();
              });
          } catch (error) {
            console.error(error);
            this.saveSubmitLoading = false;
            (this.$refs.table as any).$refs.table.clearSelection();
          }
        }
      }
    );
  }

  private async handleFee(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.$router.push(
              `/otherExpensesManagement?hqPackingListId=${this.id}&supplierId=${this.headForm.supplierId}&hqCode=${this.headForm.code}`
            );
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }

  // 保存到装箱单
  private async saveToPackingList(created) {
    this.saveSubmitLoading = true;
    try {
      await saveToPackingList(this.id, {
        supplierId: this.headForm.supplierId,
        packingListRemark: this.headForm.packingListRemark,
        subWarehouseReceiptRemark: this.headForm.subWarehouseReceiptRemark,
        created,
      });
      await updateHqPackingListFile({hqPackingListId: this.id});
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      (this.$refs.table as any).$refs.table.clearSelection();
      await this.getList();
    } catch (error) {
      console.error(error);
    }finally {
      this.saveSubmitLoading = false;
    }
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = [];
    this.selectedRows = rows;
    console.log("selectedRows", rows);
  }

  private async updateMark() {
    await updateMark(this.id,this.markInput.join('；'))
    .then(() => {
        this.$notify({
        title: "成功",
        message: "更新唛头成功",
        type: "success",
        duration: 2000,
      });
    }).catch((err) => {
      console.error(err);
    });
    this.updateMarkVisible = false;
    this.markInput = [];
  }

  private async getMark() {
    const poCodes = this.table.list.map(item => {
      return item.purchaseOrderNumber;
    });
    const markLetters: any = await queryMarkLetter(poCodes,'');
    this.markLetters = markLetters
    const mark: any = await getMark(this.id);
    if (mark && mark.length > 0) {
      // 处理如果是纯数字，造成无法使用indexOf函数的问题
      let markConvert:String = new String(mark);
      if (markConvert.indexOf('；')){
        const split:any = markConvert.split('；');
        this.markInput = split;
      }else {
        let array = [];
        array.push(markConvert);
        this.markInput = array;
      }
    }
  }

}
